import { UserOutlined } from "@ant-design/icons";
import { getText, Tlt } from "@clairejs/react";
import { Outlet, useNavigator } from "@clairejs/react-web";
import { Avatar, Breadcrumb, Dropdown, Layout, theme } from "antd";
import { Suspense, useMemo, useState } from "react";

import imgLogo from "../../assets/images/logo.svg";

import { sessionActions } from "../../store/action/session";

import { smallTextFontSize } from "../../utils/style";

import { useDispatch, useStore } from "../../hooks/system";

import LanguageSwitcher from "../../components/language-switcher";
import AppMenu from "./menu";
import ProfileSettings from "./profile-settings";
import ColorModeSwitcher from "../../components/color-mode-switcher";

const { Header, Content, Footer, Sider } = Layout;

function UserDropdown() {
    const navigator = useNavigator();
    const dispatch = useDispatch();
    const me = useStore((s) => s.me);

    const [showUpdate, setShowUpdate] = useState(false);

    const logout = async () => {
        await dispatch(sessionActions.logout());
        navigator.navigate("/");
    };

    return (
        <>
            <Dropdown
                trigger={["click"]}
                menu={{
                    items: [
                        {
                            key: "profile",
                            type: "item",
                            label: getText(<Tlt template="Update profile" />),
                            onClick: () => setShowUpdate(true),
                        },
                        {
                            key: "logout",
                            type: "item",
                            label: getText(<Tlt template="Sign out" />),
                            onClick: () => logout(),
                        },
                    ],
                }}>
                <div style={{ display: "flex", alignItems: "center", gap: 13, cursor: "pointer" }}>
                    <div>{me?.info?.displayName || me?.info?.readableId}</div>
                    <Avatar src={me?.info?.avatar} icon={<UserOutlined />} />
                </div>
            </Dropdown>
            {showUpdate && <ProfileSettings onClose={() => setShowUpdate(false)} />}
        </>
    );
}

function AppBreadcrumbs() {
    const navigator = useNavigator();

    const path = navigator.getPath();

    const crumbs = useMemo(() => {
        const segs = path.split("/").filter(Boolean);
        return segs;
    }, [path]);

    return (
        <Breadcrumb
            items={crumbs.map((seg) => ({
                title: (
                    <span style={{ textTransform: "capitalize" }}>
                        <Tlt exp={seg} />
                    </span>
                ),
            }))}
        />
    );
}

export default function AdminLayout() {
    const { token } = theme.useToken();

    const [collapsed, setCollapsed] = useState(false);

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <img alt="logo" src={imgLogo} style={{ height: 32, margin: 16 }} />
                </div>
                <AppMenu />
            </Sider>
            <Layout>
                <Header
                    style={{
                        background: token.colorBgLayout,
                        padding: "0 21px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                    <AppBreadcrumbs />
                    <UserDropdown />
                </Header>
                <Content style={{ padding: "13px 21px", background: token.colorBgBase, display: "flex" }}>
                    <Suspense>
                        <Outlet />
                    </Suspense>
                </Content>
                <Footer style={{ padding: "8px 21px", textAlign: "right", fontSize: smallTextFontSize }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
                            <LanguageSwitcher />
                            <ColorModeSwitcher />
                        </div>
                        <div>by tamidi.com</div>
                    </div>
                </Footer>
            </Layout>
        </Layout>
    );
}
